import { Component, EventEmitter, Input, OnInit, Output, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import moment, { Moment } from 'moment';
import 'moment/locale/pt-br';

interface DiaCalendario {
  data: Moment;
  numero: number;
  foraDoMes: boolean;
  desabilitado: boolean;
}

@Component({
  selector: 'app-calendario',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './calendario.component.html',
  styleUrl: './calendario.component.css'
})
export class CalendarioComponent implements OnInit {
  @Input() dataSelecionada: Moment | null = null;
  @Input() dataMinima: Moment | null = null;

  @Output() selecionarData = new EventEmitter<Moment>();

  readonly diasSemana = ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'];

  mesAtual!: Moment;
  visualizacao = signal<'dias' | 'anos'>('dias');
  anoBase = 0;

  ngOnInit() {
    this.mesAtual = (this.dataSelecionada ?? moment()).clone().locale('pt-br').startOf('month');
  }

  get tituloMes(): string {
    const texto = this.mesAtual.format('MMMM YYYY');
    return texto.charAt(0).toUpperCase() + texto.slice(1);
  }

  get tituloAnos(): string {
    return `${this.anoBase} - ${this.anoBase + 11}`;
  }

  get dias(): DiaCalendario[] {
    const inicioMes = this.mesAtual.clone().startOf('month');
    const fimMes = this.mesAtual.clone().endOf('month');
    const inicioGrade = inicioMes.clone().startOf('week');
    const fimGrade = fimMes.clone().endOf('week');

    const dias: DiaCalendario[] = [];
    const cursor = inicioGrade.clone();
    while (cursor.isSameOrBefore(fimGrade, 'day')) {
      dias.push({
        data: cursor.clone(),
        numero: cursor.date(),
        foraDoMes: cursor.month() !== this.mesAtual.month(),
        desabilitado: !!this.dataMinima && cursor.isBefore(this.dataMinima, 'day'),
      });
      cursor.add(1, 'day');
    }
    return dias;
  }

  get anosGrade(): number[] {
    return Array.from({ length: 12 }, (_, i) => this.anoBase + i);
  }

  navAnterior() {
    if (this.visualizacao() === 'anos') {
      this.anoBase -= 12;
    } else {
      this.mesAtual = this.mesAtual.clone().subtract(1, 'month');
    }
  }

  navProximo() {
    if (this.visualizacao() === 'anos') {
      this.anoBase += 12;
    } else {
      this.mesAtual = this.mesAtual.clone().add(1, 'month');
    }
  }

  alternarVisualizacao() {
    if (this.visualizacao() === 'dias') {
      this.anoBase = this.mesAtual.year() - (this.mesAtual.year() % 12);
      this.visualizacao.set('anos');
    } else {
      this.visualizacao.set('dias');
    }
  }

  selecionarAno(ano: number) {
    this.mesAtual = this.mesAtual.clone().year(ano);
    this.visualizacao.set('dias');
  }

  selecionarDia(dia: DiaCalendario) {
    if (dia.desabilitado) {
      return;
    }
    if (dia.foraDoMes) {
      this.mesAtual = dia.data.clone().startOf('month');
    }
    this.selecionarData.emit(dia.data.clone());
  }

  ehHoje(dia: DiaCalendario): boolean {
    return dia.data.isSame(moment(), 'day');
  }

  ehSelecionado(dia: DiaCalendario): boolean {
    return !!this.dataSelecionada && dia.data.isSame(this.dataSelecionada, 'day');
  }
}
